export default (input: string | null | undefined): string => {
  if (input === null || input === undefined) {
    return '';
  }

  return `${input}`.trim();
};
